import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState<number | null>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleSections, setVisibleSections] = useState<Set<string>>(new Set());

  const servicesData = [
    {
      title: t('services.list.interiorDesign.title'),
      description: t('services.list.interiorDesign.description'),
      image: 'https://public.readdy.ai/ai/img_res/9b0411756994e94d30cc8a3fda5a74a0.jpg',
      detailImages: [
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/ad79efb2ae30c54dd45466b34d9d6af8.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/825ef13f21026df6e58cfd83baa0d558.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/d9c2c219f079c997229b6a06c2942fad.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/5bd73f8e7043ab06ac7b10394abc8337.jpeg',
      ],
      detailText: t('services.details.interiorDesign'),
    },
    {
      title: t('services.list.construction.title'),
      description: t('services.list.construction.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20construction%20site%20with%20clean%20architectural%20lines%20professional%20building%20work%20contemporary%20structure%20high%20quality%20craftsmanship%20minimalist%20design%20neutral%20background%20construction%20excellence%20architectural%20detail%20premium%20building%20materials&width=800&height=1000&seq=service-construction-001&orientation=portrait',
      detailImages: [
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/03a771be242a51a3a18c54f4cf6ea3be.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/d8022d16d06abebfd3c7fac53a3058ae.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/aad03330296d58032346af0eb6e86aa1.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/179d31ede00835828b0d9ef00c097802.jpeg',
      ],
      detailText: t('services.details.construction'),
    },
    {
      title: t('services.list.furniture.title'),
      description: t('services.list.furniture.description'),
      image: 'https://readdy.ai/api/search-image?query=Custom%20made%20luxury%20furniture%20piece%20elegant%20craftsmanship%20modern%20design%20high%20quality%20materials%20minimalist%20aesthetic%20professional%20product%20photography%20neutral%20background%20sophisticated%20woodwork%20contemporary%20furniture%20design%20premium%20finish&width=800&height=1000&seq=service-furniture-001&orientation=portrait',
      detailImages: [
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/725c76cacbf19cc6b65b8b1976e30352.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/b2dbdf93cee884af26e4b11b6ff7f029.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/a8be32c680cae3f00d149ebc78af9775.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/1591b63f0807abfe5bcf72da46f3e4b5.jpeg',
      ],
      detailText: t('services.details.furniture'),
    },
    {
      title: t('services.list.cnc.title'),
      description: t('services.list.cnc.description'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20CNC%20milling%20machine%20creating%20precise%20wooden%20components%20modern%20manufacturing%20technology%20high%20precision%20woodworking%20clean%20workshop%20environment%20sophisticated%20machinery%20neutral%20background%20advanced%20fabrication%20equipment%20contemporary%20production%20process%20quality%20craftsmanship&width=800&height=1000&seq=service-cnc-milling-001&orientation=portrait',
      detailImages: [
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/dc1f7a3a05e9964eb51097adbfa8126b.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/1eb03f223d4cd3fff02e69f37ab302fb.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/8e62d99f7640a5d72ab45d3599f3a18a.jpeg',
        'https://static.readdy.ai/image/21e92476ad71fc9ba2123db9df7d7eb8/b8a519066fea5364b31d3fd54028c5d8.jpeg',
      ],
      detailText: t('services.details.cnc'),
    },
  ];

  const services = [
    {
      title: t('services.list.interiorDesign.title'),
      description: t('services.list.interiorDesign.description'),
      image: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20interior%20design%20living%20room%20with%20elegant%20furniture%20sophisticated%20color%20scheme%20natural%20light%20clean%20minimalist%20aesthetic%20high%20end%20residential%20space%20professional%20architectural%20photography%20neutral%20tones%20premium%20materials%20contemporary%20style&width=800&height=1000&seq=service-interior-001&orientation=portrait',
    },
    {
      title: t('services.list.construction.title'),
      description: t('services.list.construction.description'),
      image: 'https://readdy.ai/api/search-image?query=Modern%20construction%20site%20with%20clean%20architectural%20lines%20professional%20building%20work%20contemporary%20structure%20high%20quality%20craftsmanship%20minimalist%20design%20neutral%20background%20construction%20excellence%20architectural%20detail%20premium%20building%20materials&width=800&height=1000&seq=service-construction-001&orientation=portrait',
    },
    {
      title: t('services.list.furniture.title'),
      description: t('services.list.furniture.description'),
      image: 'https://readdy.ai/api/search-image?query=Custom%20made%20luxury%20furniture%20piece%20elegant%20craftsmanship%20modern%20design%20high%20quality%20materials%20minimalist%20aesthetic%20professional%20product%20photography%20neutral%20background%20sophisticated%20woodwork%20contemporary%20furniture%20design%20premium%20finish&width=800&height=1000&seq=service-furniture-001&orientation=portrait',
    },
    {
      title: t('services.list.cnc.title'),
      description: t('services.list.cnc.description'),
      image: 'https://readdy.ai/api/search-image?query=Professional%20CNC%20milling%20machine%20creating%20precise%20wooden%20components%20modern%20manufacturing%20technology%20high%20precision%20woodworking%20clean%20workshop%20environment%20sophisticated%20machinery%20neutral%20background%20advanced%20fabrication%20equipment%20contemporary%20production%20process%20quality%20craftsmanship&width=800&height=1000&seq=service-cnc-milling-001&orientation=portrait',
    },
  ];

  const [projectsCount, setProjectsCount] = useState(0);
  const [yearsCount, setYearsCount] = useState(0);
  const [satisfactionCount, setSatisfactionCount] = useState(0);
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const sectionId = entry.target.getAttribute('data-section');
            if (sectionId) {
              setVisibleSections((prev) => new Set(prev).add(sectionId));
            }
            
            if (entry.target === statsRef.current && !hasAnimated) {
              setHasAnimated(true);
              animateCounter(setProjectsCount, 560, 2000);
              animateCounter(setYearsCount, 21, 2000);
              animateCounter(setSatisfactionCount, 100, 2000);
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    const sections = document.querySelectorAll('[data-section]');
    sections.forEach((section) => observer.observe(section));

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, [hasAnimated]);

  useEffect(() => {
    if (selectedService !== null) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedService]);

  const animateCounter = (setter: (value: number) => void, target: number, duration: number) => {
    const startTime = Date.now();
    const step = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOutQuad = 1 - Math.pow(1 - progress, 3);
      const current = Math.floor(easeOutQuad * target);
      setter(current);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        setter(target);
      }
    };
    requestAnimationFrame(step);
  };

  const openServiceModal = (index: number) => {
    setSelectedService(index);
    setCurrentImageIndex(0);
  };

  const closeServiceModal = () => {
    setSelectedService(null);
    setCurrentImageIndex(0);
  };

  const nextImage = () => {
    if (selectedService !== null) {
      setCurrentImageIndex((prev) => 
        prev === servicesData[selectedService].detailImages.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedService !== null) {
      setCurrentImageIndex((prev) => 
        prev === 0 ? servicesData[selectedService].detailImages.length - 1 : prev - 1
      );
    }
  };

  return (
    <>
      {/* Services Introduction */}
      <section className="py-32 bg-white" data-section="intro">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
            <div className={`transition-all duration-1000 ease-out ${
              visibleSections.has('intro') ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}>
              <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 leading-tight">
                {t('services.intro.title')}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-6 font-light">
                {t('services.intro.description1')}
              </p>
              <p className="text-lg text-gray-600 leading-relaxed font-light">
                {t('services.intro.description2')}
              </p>
            </div>
            <div className={`relative h-[600px] transition-all duration-1000 ease-out ${
              visibleSections.has('intro') ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`} style={{ transitionDelay: '200ms' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20designer%20workspace%20with%20fabric%20swatches%20material%20samples%20color%20palette%20boards%20architectural%20blueprints%20design%20magazines%20mood%20boards%20on%20large%20wooden%20table%20creative%20studio%20environment%20natural%20daylight%20modern%20office%20space%20design%20consultation%20setup%20elegant%20workspace%20contemporary%20interior%20design%20planning%20process&width=700&height=900&seq=intro-workspace-003&orientation=portrait"
                alt={t('services.intro.imageAlt')}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-32 bg-gray-50" data-section="services-grid">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className={`text-center mb-20 transition-all duration-1000 ease-out ${
            visibleSections.has('services-grid') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-6">
              {t('services.title')}
            </h2>
            <p className="text-lg text-gray-600 font-light max-w-2xl mx-auto">
              {t('services.subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                onClick={() => openServiceModal(index)}
                className={`group cursor-pointer bg-white overflow-hidden transition-all duration-700 hover:shadow-2xl ${
                  visibleSections.has('services-grid') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${200 + index * 100}ms` }}
              >
                <div className="relative overflow-hidden h-[500px]">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                </div>
                <div className="p-10">
                  <h3 className="text-2xl font-light text-gray-900 mb-4 group-hover:text-gray-600 transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed font-light mb-6">
                    {service.description}
                  </p>
                  <div className="flex items-center text-sm font-medium text-gray-900 group-hover:text-gray-600 transition-colors">
                    <span className="tracking-wide">{t('services.learnMore')}</span>
                    <i className="ri-arrow-right-line ml-2 transform group-hover:translate-x-2 transition-transform"></i>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Detail Modal */}
      {selectedService !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 animate-fadeIn">
          <button
            onClick={closeServiceModal}
            className="absolute top-8 right-8 text-white hover:text-gray-300 transition-colors z-10 w-12 h-12 flex items-center justify-center hover:rotate-90 duration-300"
          >
            <i className="ri-close-line text-4xl"></i>
          </button>

          <div className="w-full max-w-6xl max-h-[90vh] overflow-y-auto bg-white animate-slideUp">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Image Gallery */}
              <div className="relative bg-gray-100 h-[70vh] lg:h-auto">
                <img
                  src={servicesData[selectedService].detailImages[currentImageIndex]}
                  alt={servicesData[selectedService].title}
                  className="w-full h-full object-cover transition-opacity duration-500"
                  key={currentImageIndex}
                />
                
                {/* Navigation Arrows */}
                <button
                  onClick={prevImage}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 w-12 h-12 flex items-center justify-center transition-all hover:scale-110"
                >
                  <i className="ri-arrow-left-s-line text-2xl"></i>
                </button>
                <button
                  onClick={nextImage}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-900 w-12 h-12 flex items-center justify-center transition-all hover:scale-110"
                >
                  <i className="ri-arrow-right-s-line text-2xl"></i>
                </button>

                {/* Image Indicators */}
                <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
                  {servicesData[selectedService].detailImages.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentImageIndex(idx)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        idx === currentImageIndex ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/75'
                      }`}
                    />
                  ))}
                </div>
              </div>

              {/* Content */}
              <div className="p-12 overflow-y-auto max-h-[70vh]">
                <h2 className="text-4xl font-light text-gray-900 mb-6">
                  {servicesData[selectedService].title}
                </h2>
                <div className="text-gray-600 leading-relaxed font-light space-y-4">
                  {servicesData[selectedService].detailText}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Featured Project */}
      <section className="py-32 bg-white" data-section="featured">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className={`relative h-[700px] transition-all duration-1000 ease-out ${
              visibleSections.has('featured') ? 'opacity-100 -translate-x-0' : 'opacity-0 -translate-x-10'
            }`}>
              <img
                src="https://readdy.ai/api/search-image?query=Stunning%20modern%20interior%20design%20project%20showcase%20elegant%20residential%20space%20with%20sophisticated%20furniture%20arrangement%20natural%20light%20minimalist%20aesthetic%20neutral%20color%20palette%20high%20end%20finishes%20contemporary%20architecture%20professional%20interior%20photography&width=800&height=1000&seq=featured-project-001&orientation=portrait"
                alt={t('services.featured.label')}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className={`transition-all duration-1000 ease-out ${
              visibleSections.has('featured') ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'
            }`} style={{ transitionDelay: '200ms' }}>
              <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 leading-tight">
                {t('services.featured.title')}<br />{t('services.featured.titleLine2')}
              </h2>
              <p className="text-lg text-gray-600 leading-relaxed mb-8 font-light">
                {t('services.featured.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section ref={statsRef} className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
            <div className="text-center transform hover:scale-110 transition-transform duration-300">
              <div className="text-6xl font-light mb-4 text-[#5f7074]">{projectsCount}+</div>
              <p className="text-sm tracking-widest text-[#5f7074] font-light">{t('services.stats.projects')}</p>
            </div>
            <div className="text-center transform hover:scale-110 transition-transform duration-300" style={{ transitionDelay: '100ms' }}>
              <div className="text-6xl font-light mb-4 text-[#5f7074]">{yearsCount}+</div>
              <p className="text-sm tracking-widest text-[#5f7074] font-light">{t('services.stats.years')}</p>
            </div>
            <div className="text-center transform hover:scale-110 transition-transform duration-300" style={{ transitionDelay: '200ms' }}>
              <div className="text-6xl font-light mb-4 text-[#5f7074]">{satisfactionCount}%</div>
              <p className="text-sm tracking-widest text-[#5f7074] font-light">{t('services.stats.satisfaction')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 bg-white" data-section="cta">
        <div className={`max-w-[1400px] mx-auto px-8 text-center transition-all duration-1000 ease-out ${
          visibleSections.has('cta') ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-5xl md:text-6xl font-light text-gray-900 mb-8 leading-tight">
            {t('services.cta.title')}<br />{t('services.cta.titleLine2')}
          </h2>
          <p className="text-lg text-gray-600 mb-12 font-light max-w-2xl mx-auto">
            {t('services.cta.description')}
          </p>
          <Link
            to="/contact"
            className="inline-block px-12 py-5 bg-gray-900 text-white text-sm font-medium tracking-widest hover:bg-gray-800 transition-all duration-300 whitespace-nowrap hover:scale-105 hover:shadow-xl"
          >
            {t('services.cta.button')}
          </Link>
        </div>
      </section>
    </>
  );
}
